module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/Microsoft_Logo_Light_Background.79bb612056f76b04dcf0b1c668e48fbc.png";